import { Alert, CircularProgress, Modal, Snackbar } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servEquipamentos from "../../../services/login/servEquipamentos";
import { style as modalStyle } from "../../../components/Loading/Loading";
import "./style.css"
import { Box } from "@mui/system";


const SolicitarHomologacao = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleCloseError = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarHomologacao = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {

            setIsLoading(true);

            await servEquipamentos.SolicitarHomologacao(recordForEdit?.Id || recordForEdit?.row?.Id);
            
            setIsLoading(false);

            setOpenPopup(false);

            pesquisar();

        } catch (err) {
            setIsLoading(false);

            setErrorMessage(err.response.data.Message);
            return setOpenErrorWindow(true);
        }
        
    }

    return (
        <div style={{ width: "100%", height: "20%" }}>
            <h4>
                Você deseja enviar o equipamento para homologação? <br />
                Após o envio, o equipamento só poderá ser alterado em uma eventual reprovação.
            </h4>
            <div className="homologacao_botoes">
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Cancelar</BlueHoverButton>
                <BlueHoverButton onClick={solicitarHomologacao}>Homologar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { SolicitarHomologacao };